$shm_service_filter_panel $mol_page
	title \Фильтры
	reset_title \Сбросить
	reset? null
	filter_rows /$mol_view
	tools /
		<= Filter_reset $mol_button_minor
			title <= reset_title
			click? <=> reset? null
	body /
		<= Filters $mol_list
			rows <= filter_rows
